'use strict';
var angular = require('angular');
var Promise = require('bluebird');
var sanitizeMongoKeys = require('../utils/sanitizeMongoKeys');
// Configure
Promise.config({
    longStackTraces: true,
    warnings: true
});

module.exports = function (Department,$translate) {

    var newItem = {
        addPage: function () {
            if (!this.pages) {
                this.pages = [];
            }

            this.pages.push({
                id: Math.random().toString(36).substr(2, 9),
                requires: [],
                fields: [],
                type: 'page'
            });
        },
        removePage: function (index) {
            if (this.pages.length < 2) {
                return;
            }
            this.pages.splice(index, 1);
        },
        movePage: function(index, direction) {
            // console.log('this.pages', this.pages);
            // console.log('index', index);
            // console.log('direction', direction);

            // Calculate the new index
            const newIndex = index + direction;
            // console.log('newIndex', newIndex);
        
            // Check if the new index is within the array bounds
            if (newIndex >= 0 && newIndex < this.pages.length) {
                // Swap the elements
                const temp = this.pages[index];
                this.pages[index] = this.pages[newIndex];
                this.pages[newIndex] = temp;
                // console.log('this.pages modificado', this.pages);
            }
        },
        save: function (departmentId) {
            var _this = this;
            if (!departmentId) {
                return Promise.reject(new Error($translate.instant("DASHBOARD.DASH_BUILDER.FORM_FACTORY.SAVE_ERR_DEPTO")));
            }
            if (!this.name) {
                // || !this.description
                return Promise.reject(new Error($translate.instant("DASHBOARD.DASH_BUILDER.FORM_FACTORY.SAVE_ERR_NAME")));
            }

            const now = new Date().toISOString();
            function setSavedStateUpdatedAt(fields) {
                if (!Array.isArray(fields)) return;
                fields.forEach(function (el) {
                    if (el && el.type === 'grid' && el.savedState) {
                        el.savedStateUpdatedAt = now;
                    }
                    if (el && el.nodes && Array.isArray(el.nodes)) {
                        setSavedStateUpdatedAt(el.nodes);
                    }
                });
            }
            if (this.pages && Array.isArray(this.pages)) {
                this.pages.forEach(function (page) {
                    if (page && page.fields) setSavedStateUpdatedAt(page.fields);
                });
            }

            if (this.id) {
                var id = this.id;

                delete this.id;
                delete this.departmentId;
                delete this.tenantId;
                delete this.$promise;
                delete this.$resolved;
                var updatePayload = sanitizeMongoKeys(JSON.parse(angular.toJson(this)));
                return Department.graphs.updateById({
                        id: departmentId,
                        fk: id
                    }, updatePayload)
                    .$promise.then(function () {
                        _this.id = id;
                        return _this;
                    })
                    // this.$save();
            }

            var createPayload = sanitizeMongoKeys(JSON.parse(angular.toJson(this)));
            return Department.graphs.create({
                        id: departmentId
                    },
                    createPayload)
                .$promise;
        },
        destroy: function () {
            return Department.graphs.destroyById({
                    id: this.departmentId,
                    fk: this.id
                },
                this).$promise;
        },
        removeElement: function (id) {
            function removeInnerArray(fields,id){
                fields.forEach(function (element, index) {
                        if(element.id==id){
                            fields.splice(index,1);
                        }else if(element.nodes && element.nodes.length>0)
                            removeInnerArray(element.nodes,id);
                            
                });

            }
            this.pages.forEach(function (page) {
                removeInnerArray(page.fields,id);
            });
        },
        cloneElement: function (id) {
            let idMappings = {}; // Object to store the mappings of old and new IDs
            let mainClonedElement = null;
        
            function cloneInnerArray(fields, id) {
                fields.forEach(function (element, index) {
                    if (element.id == id) {
                        // Clone element
                        // let clonedElement = JSON.parse(JSON.stringify(element));
                        let clonedElement = angular.copy(element);
                        updateElement(clonedElement);
                        fields.splice(index + 1, 0, clonedElement);
        
                        // Save the main cloned element
                        mainClonedElement = fields[index + 1];
                    }
                    else if (element.nodes && element.nodes.length > 0) {
                        cloneInnerArray(element.nodes, id);
                    }
                });
            }
        
            function updateElement(element) {
                let oldId = element.id
                let newId = Math.random().toString(36).substr(2, 9);
                element.id = newId;
                idMappings[oldId] = newId; // Save old and new Id
                delete element.$$hashKey;
                // if (element.nodes && Array.isArray(element.nodes)) {
                //     element.nodes.forEach(updateElement);
                // }
            }
        
            this.pages.forEach(function (page) {
                cloneInnerArray(page.fields, id);
            });

            // function walkProperties(obj) {
            //     if (obj && typeof obj === "object") {
            //         Object.keys(obj).forEach(key => {
            //             if (typeof obj[key] === "string") {
            //                 if (idMappings[obj[key]] !== undefined) {
            //                     obj[key] = idMappings[obj[key]];
            //                 }
            //             } else if (Array.isArray(obj[key])) {
            //                 obj[key].forEach(el => {
            //                     if (typeof el === "object") {
            //                         walkProperties(el);
            //                     }
            //                 });
            //             } else if (typeof obj[key] === "object") {
            //                 walkProperties(obj[key]);
            //             }
            //         });
            //     }
            // }
            
            // // Replace old Id in clone elements
            // if (mainClonedElement) {
            //     walkProperties(mainClonedElement);
            // }
            // console.log('this.pages', this.pages);
        },
        addElementToEnd: function (element) {
            let clonedElement = JSON.parse(JSON.stringify(element));
            delete clonedElement.$$hashKey;
            clonedElement.id = Math.random().toString(36).substr(2, 9);
            this.pages[this.pages.length - 1].fields.push(clonedElement);
        }
    };

    return {
        new: function () {
            var temp = Object.create(newItem);
            temp.addPage();
            return temp;
        },
        load: function (data) {
            var temp = Object.create(newItem);
            angular.extend(temp, data);

            return temp;
        }
    };
};